import { createSelector } from 'reselect';

import getMenu from './getMenu';
import getIsShelvesMenuLayout from './getIsShelvesMenuLayout';

const getShelvesMenuLoadStatus = createSelector(
  getIsShelvesMenuLayout,
  getMenu,
  (isShelvesLayout, menu) =>
    menu && isShelvesLayout
      ? {
          count: menu.sections.length,
          hasMore: menu.count < menu.total,
        }
      : null,
);

export default getShelvesMenuLoadStatus;
